import '../app.es6';
import angular from 'angular';

class LoginType {
  /* @ngInject */
  constructor ($location) {
    this.$location = $location;

    LoginType.$inject = ['$location'];
  }

  get () {
    return this.$location.path().match('/c/') ? 'coach' : 'player';
  }

  getShorthand () {
    return this.get().charAt(0);
  }
}

angular.module('myApp').service('LoginType', LoginType);



// WEBPACK FOOTER //
// ./app/services/login-type.es6